export const translations = {
  codigo: {
    pt: 'Código',
    en: 'Code',
    de: 'Code',
    es: 'Código',
  },
  nomeFantasia: {
    pt: 'Nome Fantasia',
    en: 'Fantasy name',
    de: 'Fantasiename',
    es: 'Nombre de fantasía',
  },
  cnpj: {
    pt: 'CNPJ',
    en: 'CNPJ',
    de: 'CNPJ',
    es: 'CNPJ',
  },
  cidade: {
    pt: 'Cidade',
    en: 'City',
    de: 'Ort',
    es: 'Ciudad',
  },
  sap_p08: {
    pt: 'SAP P08',
    en: 'SAP P08',
    de: 'SAP P08',
    es: 'SAP P08',
  },
  sap_pbc: {
    pt: 'SAP PBC',
    en: 'SAP PBC',
    de: 'SAP PBC',
    es: 'SAP PBC',
  },
};
